// Ecom XL gallery images. Sizes come from the AW26 internal fit list.
// Products not listed keep the existing size L badge.
const MODEL_WEAR_SIZE_BY_HANDLE = {
  "casablanca-dress": "L",
  "lorela-dress": "L",
  "navarra-dress-lime": "L",
  "donyale-dress": "L",
  "sirena-dress-pink": "L",
  "aralia-dress-zebra": "L",
  "catarina-dress": "L",
  "valentina-dress": "M",
  "leontina-dress": "M",
  "odessa-dress-green": "L",
  "cecelia-dress": "L",
  "olympia-sequin-dress": "L",
  "antheia-dress": "S/M",
  "magnolia-dress-pink": "M",
  "ozias-dress": "L",
  "evi-dress-red": "M",
  "odessa-dress-red": "L",
  "cristi-skirt": "M",
  "rosalba-dress-zebra": "M",
  "cova-dress": "M",
  "rosalba-dress-floral": "M",
};

export function getModelWearSizeLabel(handle) {
  const size = MODEL_WEAR_SIZE_BY_HANDLE[handle] || "L";
  return `MODEL WEARS SIZE ${size}`;
}
